import Konva from 'konva';
import { MM_PER_POINT, pixelSize, publicationCrop } from '@services/GreetingGeometry';

export function makeNode(object, images) {
    const config = {
        id: object.id,
        x: object.x,
        y: object.y,
        width: object.width,
        height: object.height,
    };
    if (object.type === 'image') {
        return new Konva.Image({ ...config, image: images.get(object.image_id) });
    }
    return new Konva.Text({
        ...config,
        height: undefined,
        text: object.text,
        fontFamily: `Greeting-${object.font}`,
        fontSize: object.font_size * MM_PER_POINT,
        fill: object.color,
        lineHeight: object.line_height,
        align: object.align,
        wrap: 'word',
        padding: 0,
    });
}

// A separate stage makes it impossible to include selection handles or proof art.
export function exportCanvas(layout, size, images, dpi = 300, background = null) {
    const pixels = pixelSize(size, dpi);
    const container = document.createElement('div');
    const stage = new Konva.Stage({ container, width: pixels.width, height: pixels.height });
    const layer = new Konva.Layer({ scaleX: pixels.width / size.width, scaleY: pixels.height / size.height });
    stage.add(layer);
    layout.objects.forEach((object) => layer.add(makeNode(object, images)));
    layer.draw();
    const canvas = stage.toCanvas({ pixelRatio: 1 });
    stage.destroy();
    if (background) {
        const context = canvas.getContext('2d');
        context.save();
        context.globalCompositeOperation = 'destination-over';
        context.fillStyle = background;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.restore();
    }
    return canvas;
}

export function pngBlob(canvas) {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) resolve(blob);
            else reject(new Error('Webbläsaren kunde inte skapa PNG-bilden.'));
        }, 'image/png');
    });
}

export function exportPublicationCanvas(layout, size, images) {
    const canvas = exportCanvas(layout, size, images, 300, '#ffffff');
    const crop = publicationCrop(layout, size);
    if (!crop.x && !crop.y) return canvas;
    const result = document.createElement('canvas');
    result.width = crop.width;
    result.height = crop.height;
    result.getContext('2d').drawImage(canvas, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    return result;
}
